import styled from 'styled-components';
import { Certificate } from '@styled-icons/fluentui-system-filled/Certificate';
import { Button } from 'antd';
import { Broom } from '@styled-icons/fluentui-system-filled/Broom';

export const Container = styled.header`
  background-color: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};

  position: absolute;
  top: -2.875rem;
  z-index: 9;
  height: 2.875rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 1.5rem;
  }

  & > div {
    & > span {
      font-size: 0.875rem;
      font-weight: 600;
      margin-right: 1rem;
      display: none;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: unset;
      }
    }
  }

  animation: opacity 0.25s ease-in;
  @keyframes opacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const DownloadLinkButton = styled(Button)`
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.875rem;
  font-weight: 600;
  opacity: 1;

  &:hover {
    opacity: 0.8;
  }

  &.clean-button {
    & > span {
      display: none;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: unset;
      }
    }
  }
`;

export const CertificateIcon = styled(Certificate)`
  width: 1rem;
  margin-right: 0.25rem;
`;

export const CleanIcon = styled(Broom)`
  width: 1rem;
  margin-right: 0.25rem;
`;
